import { getCommonProps } from '../helpers/commonHelpers';
import { CARD_TYPES } from '../../../constants';

export const prepareCardData = cardData => {
  return {
    ...getCommonProps(cardData),
    containerType: CARD_TYPES.INTERESTS,
    maxResults: cardData?.properties?.custom?.maxResults,
    subtitle: cardData?.properties?.subtitle,
    title: cardData?.properties?.title,
  };
};

export {
  getBuyingToolsIngredients,
  getAnalyticsActions,
  getAnalyticsPlacements,
  getUrlIngredients,
  mergeProperties,
  prepareTranslations,
} from './common';
